<template>
    <div class="transportContent">
        <div class="transportTitle">
            {{$translate('lang.E3202103030010', { defaultText: '物流运输' })}}
            <span class="line"></span>
        </div>
        <div class="content">
            <div class="sideBar">
                <div v-for="(item,index) in list" :key= 'index + "icon"'>
                    <div class="sideBarContent" :style='"top:" + progressHeight*index + "px"'>
                        <div class='iconShow' ref='svgShow'>
                            <span class='icon font_family'>{{item.icon}}</span>
                        </div>
                    </div>
                    <div class="columnLine" :style='"top:" + (29 + progressHeight*index) + "px"'>
                    </div>
                </div>
                <div class='sideBarContent' :style='"top:" + (progressHeight * listLength) + "px"'>
                    <div class='iconShow' ref='svgShow'>
                        <span class='icon font_family'>&#xe6a9;</span>
                    </div>
                </div>
            </div>
            <div class="main">
                <div class="mainContent" v-for="(item2, index) in list" :key='index'>
                    <div class="iconText">{{item2.label}}</div>
                    <el-row class="commomPaper itemMain">
                        <el-col :span='item.span' class="itemRow itemRowLower" v-for="(item,index) in item2.makeList" :key='index'>
                            <div class="labelText" :title='item.label'>{{item.label}}</div>
                            <el-tooltip effect="dark" :content='item.value' placement="top" v-if='item["value"].length > 34'
                                :class="[index === 0&&item.value!=''&& item2.makeList[1].value ? 'jumpOut':'']" @click='jumpOut(index,item)'>
                                <span class="valueText unitValueText" @click='jumpOut(index,item)'>{{item.value}}</span>
                            </el-tooltip>
                            <div class="valueText" v-else :class="[index === 0&&item.value!=''&& item2.makeList[1].value ? 'jumpOut':'']" @click='jumpOut(index,item,item2)'>{{item.value}}</div>
                        </el-col>
                    </el-row>
                </div>
                <div class="mainContent">
                    <div class="iconText">{{$translate('lang.E3202103030036', { defaultText: '开始' })}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { searchProTransport } from '../../../../api/productProcess.js';
const HIDDEN_CODE = ['ettaSoNo', 'ebcuNameCn', 'siteName']; // 隐藏字段(运输单号、客户、服务平台)
const PROGRESS_BAR = 155;// 进度条高度
const PROGRESS_BAR_HIDDEN = 119;// 进度条高度(隐藏节点后)
export default {
    props: {
    },
    data () {
        return {
            activeName: 'first',
            proNum: '',
            flag: false,
            list: [],
            barArr: {},
            listLength: 0,
            progressHeight: PROGRESS_BAR
        };
    },
    methods: {
        handleClick(tab, event) {
        },
        initbarArr() {
            this.barArr = {
                label: '',
                icon: '',
                makeList: [{
                    span: 8,
                    label: this.$translate('lang.E3202103030035', { defaultText: '客户订单号' }),
                    value: '',
                    key: 'customerNo'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030087', { defaultText: '运输单号' }),
                    value: '',
                    key: 'ettaSoNo'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030012', { defaultText: '客户' }),
                    value: '',
                    key: 'ebcuNameCn'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030088', { defaultText: '服务平台' }),
                    value: '',
                    key: 'siteName'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030041', { defaultText: '仓库' }),
                    value: '',
                    key: 'whName'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030044', { defaultText: '扫描时间' }),
                    value: '',
                    key: 'scanTime'
                }, {
                    span: 8,
                    label: this.$translate('lang.E3202103030089', { defaultText: '扫描人' }),
                    value: '',
                    key: 'scanOp'
                }]
            };
        },
        initData() {
            this.list = [];
            this.listLength = 0;
        },
        setproNum(proNum) {
            this.initData();
            this.proNum = proNum;
            this.flag = true;
        },
        // 获取物流运输详细信息
        getMessage() {
            if (this.flag) {
                searchProTransport(this.proNum).then(res => {
                    if (res.code === '0' && res.data) {
                        const arr = res.data;
                        arr.forEach((item, index) => {
                            this.initbarArr();
                            if (item.flag && item.flag === 'LBCS') {
                                this.barArr.makeList = this.barArr.makeList.filter(item => HIDDEN_CODE.indexOf(item.key) === -1);
                            }
                            this.progressHeight = (item.flag && item.flag === 'LBCS') ? PROGRESS_BAR_HIDDEN : PROGRESS_BAR;
                            const itemArr = Object.keys(item);
                            if (item['businessType'] === '2') {
                                this.barArr['label'] = this.$translate('lang.E3202103030038', { defaultText: '出库' });
                                this.barArr['icon'] = '\ue6aa';
                            } else if (item['businessType'] === '1') {
                                this.barArr['label'] = this.$translate('lang.E3202103030037', { defaultText: '入库' });
                                this.barArr['icon'] = '\ue6ab';
                            }
                            itemArr.map(item2 => {
                                this.barArr.makeList.forEach(item3 => {
                                    if (item3.key === item2) {
                                        item3.value = item[item2];
                                    }
                                });
                                return item2;
                            });
                            this.list.push(this.barArr);
                        });
                        this.listLength = this.list.length;
                    }
                });
                this.flag = false;
            }
        },
        jumpOut(index, item, item2) {
            if (index === 0 && item.value !== '' && item2.makeList[1].value) {
                // 跳转外部安得官网链接查询运输单
                window.open('https://www.annto.com/service/order/?orderNoFormMain=' + item.value, '_blank');
            }
        }
    }
};
</script>
<style lang="less">
.transportContent {
    .transportTitle {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #E4E7ED;
        margin-bottom: 15px;
        font-weight: 700;
        color: #333;
    }
    .content {
        position: relative;
        overflow: auto;
        max-height: calc(100vh - 370px);
        .sideBar {
            width: 80px;
        }
        .main {
            .itemMain {
                padding: 5px 15px;
                margin-top: 10px;
            }
            .mainContent {
                margin-bottom: 11px;
            }
        }
    }
    .sideBar{
        position: absolute;
        width: 40px;
        top: 10px;
        left: 0px;
        .columnLine {
            position: absolute;
            left: 13px;
            width: 0px;
            top: 29px;
            height: 121px;
            border: 1px dashed #e8e8e8;
        }
        .columnLine2 {
            position: absolute;
            left: 13px;
            top: 203px;
            width: 0px;
            height: 140px;
            border: 1px dashed #e8e8e8;
        }
        .sideBarContent {
            position: absolute;
            top: 0px;
            left: 0px;
        }
        .sideBarContent1 {
            position: absolute;
            top: 173px;
            left: 0px;
        }
        .sideBarContent2 {
            position: absolute;
            top: 347px;
            left: 0px;
        }
        .iconShow {
            background-color: #4285f5;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            position: relative;
            .icon {
                font-size: 14px;
                position: absolute;
                top: 7px;
                left: 7px;
                color: #fff;
            }
        }
    }
    .main {
        padding: 16px 0 0 40px;
        box-sizing: border-box;
    }
    .iconText {
        font-size: 12px;
    }
    .jumpOut {
        color: #4285f5 !important;
        text-decoration: underline;
        cursor: pointer;
    }
    .itemRowLower {
        height: 36px !important;
        line-height: 36px !important;
    }
}
</style>